module.exports = __webpack_public_path__ + "img/gzhj_01.2aa9de70.jpg";